import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
// (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774)
// import Link from 'next/link';
import { IconArrow01 } from 'sections/Resources/FreightForwarder/landing/assets/Svg';
import styles from 'sections/Resources/FreightForwarder/landing/components/SectionHeader/SectionHeader.module.scss';

const cn = classNames.bind(styles);

type SectionHeaderProps = {
  country: string;
  countryIsoAlpha02: string;
};

const SectionHeader = ({ country, countryIsoAlpha02 }: SectionHeaderProps): ReactElement => {
  return (
    <section className={cn('header')}>
      <div className={cn('container')}>
        <div className={cn('header__image-box')}>
          <img
            className={cn('header__image')}
            src='/images/pages/Resources/FreightForwarder/landings/planet.webp'
            alt='image'
          />
        </div>
        <div className={cn('header__content')}>
          <div className={cn('header__heading-box')}>
            <h1 className={cn('header__heading')}>
              {IconArrow01}
              <span>Freight Forwarder in</span>{' '}
              <span><span className={cn('header__heading-country-box')}>
                {country}
                {/* <i className={`freight-forwarder-landing__head-flag flag-icon flag-icon-${countryIsoAlpha02}`} /> */}
                <i className={cn('header__flag', 'flag-icon', `flag-icon-${countryIsoAlpha02}`)} />
              </span></span>
            </h1>
            <p className={cn('header__heading-description')}>
              Learn how to grow your freight forwarding business in {country} with DF Alliance.
            </p>
            {/* (!) New user registration disabled (by the https://searate.atlassian.net/browse/IMPACT-2774) */}
            {/* <div className={cn('header__buttons')}>
              <Link className={cn('header__button-sign-up')} href='/membership'>
                Get Membership Now
              </Link>
            </div> */}
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionHeader;
